// Models
import { IGetOrCreateContractLiquidation } from '@models/ResumeLiquidation';
// Api
import axiosClient from './axiosClient';
// Urls
import { urls } from './urls';

export const apiPostContractLiquidation = <T>(data: IGetOrCreateContractLiquidation): Promise<T> =>
    axiosClient.post(urls.payslip.liquidation.contractLiquidation, data, false);
